import React from 'react';
import AboutInfo from '../AboutInfo/AboutInfo';

const AboutUs = () => {
    return (
        <div className="container aboutUs-background">
            <AboutInfo />
        </div>
    );
};

export default AboutUs;